"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderDataMenu = exports.CoreHeaderDataMenu = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var uuid_1 = require("uuid");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Button_1 = require("../Button");
var Bubble_1 = require("../Bubble");
exports.CoreHeaderDataMenu = function (_a) {
    var intl = _a.intl, onMenuItemClick = _a.onMenuItemClick, dataMenuItems = _a.dataMenuItems, className = _a.className;
    var renderSection = function (items) {
        return items.map(function (item) {
            var isDisable = item.isDisable, tooltipText = item.tooltipText, isActive = item.isActive, className = item.className, key = item.key, onClick = item.onClick;
            var classNames = classnames_1.default("gd-button-primary " + className, {
                "is-active": !isDisable && isActive,
                "is-normal": !isDisable && !isActive,
            });
            var clickHandler = onClick ? onClick : function () { return onMenuItemClick(item); };
            return (react_1.default.createElement("li", { key: key },
                react_1.default.createElement(Bubble_1.BubbleHoverTrigger, { tagName: "div", hideDelay: 100, showDelay: 100, className: "gd-bubble-trigger-data-menu" },
                    react_1.default.createElement(Button_1.Button, { onClick: clickHandler, className: classNames, value: intl.formatMessage({ id: "" + key }), disabled: isDisable }),
                    tooltipText && isDisable ? (react_1.default.createElement(Bubble_1.Bubble, { alignPoints: [{ align: "bc tc" }, { align: "bc tl" }, { align: "bc tr" }] }, tooltipText)) : null)));
        });
    };
    var dataMenuClassName = classnames_1.default("gd-data-header-menu-section", className);
    return (react_1.default.createElement("div", { className: "gd-data-header-menu-wrapper" },
        react_1.default.createElement("ul", { key: "section-" + uuid_1.v4(), className: dataMenuClassName }, renderSection(dataMenuItems))));
};
/**
 * @internal
 */
exports.HeaderDataMenu = react_intl_1.injectIntl(exports.CoreHeaderDataMenu);
//# sourceMappingURL=HeaderDataMenu.js.map